<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <wiz-hgroup width="100%" height="30px" verticalAlign="center" padding="3px" gap="2">
    <wiz-label #lbTitle width="100%" class="componentLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <wiz-hgroup #mainGP wizValidationContainer width="100%" padding="5px" verticalAlign="end">
    <wiz-checkbox #cb [visible]="isBoolean" [wizTriStateMode]="true" [wizLabel]="label" ([wizCheckState])="booleanValue"></wiz-checkbox>
    <wiz-text-input
      #ti
      [visible]="isText"
      [wizLabel]="label"
      [wizMaxChars]="50"
      ([wizValue])="textValue"
      wizValidator
      width="300px"
    ></wiz-text-input>
    <wiz-numeric-input
      #ni
      [visible]="isNum"
      [wizLabel]="label"
      ([wizNumber])="numValue"
      wizFocusMode="PASS"
      [wizMaxChars]="20"
      wizValidator
      width="150px"
    ></wiz-numeric-input>
    <wiz-datefield #da [visible]="isDate" [wizLabel]="label" width="150px" wizValidator></wiz-datefield>
    <wiz-timefield #tf [wizLabel]="label" [visible]="isTime" width="150px" wizValidator></wiz-timefield>
    
    <wiz-vgroup [visible]="usecolor" width="100%" height="100%">
      <wiz-label #colorLbl  
      [wizLabel]="label"
      class="componentLabel" 
      ></wiz-label>
      <wiz-hgroup>
        <span
          #cellBlockBack
          [style.backgroundColor]="textValue"
          width="20px"
          height="20px"
          (click)="showColorPicker($event)"
          style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
        ></span>
        <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockBack')">removal</wiz-icon>
      </wiz-hgroup>
    </wiz-vgroup>
    
    <wiz-text-area
      #ta
      [visible]="isComment"
      [wizLabel]="label"
      [wizMaxChars]="50"
      ([wizValue])="textValue"
      height="80px"
      width="300px"
    ></wiz-text-area>

    <wiz-translation-basic #trsLabel
      [visible]="isTranslatable"
      [translationData]="translationData"
      [wizLabel]="label" width="300px"
    >
    </wiz-translation-basic>



    <wiz-spacer width="100%"></wiz-spacer>
    <wiz-button
      [wizLabel]="editLbl"
      [wizIcon]="'icon-arrow-right'"
      (click)="saveSingle()"
      [iconPlacement]="'right'"
      width="150px"
    ></wiz-button>
    <wiz-button
      [wizLabel]="'$.pivot.mass.edit.split.$'"
      [visible]="isNum && isMultiple"
      [wizIcon]="'icon-arrow-right'"
      (click)="saveSplit()"
      [iconPlacement]="'right'"
      width="150px"
    ></wiz-button>
  </wiz-hgroup>

  <wiz-hgroup [visible]="isMultiple" padding="5px" verticalAlign="center" (click)="toggleShowEditDetail()">
    <wiz-icon [visible]="!showDetail" class="image-purple">add</wiz-icon>
    <wiz-icon [visible]="showDetail" class="image-purple">reduce</wiz-icon>

    <wiz-label #lblShowHide [wizLabel]="'$.pivot.editpop.showdetail.$'" class="smallTitleLabel"></wiz-label>
  </wiz-hgroup>

  <wiz-hgroup padding="5px" [visible]="showDetail" width="100%" height="100%">
    <wiz-ag-grid #agGrid width="100%" height="100%" [wizDatasource]="mainDS" class="ag-theme-alpine"></wiz-ag-grid>
  </wiz-hgroup>
</wiz-vgroup>
